module.exports = __webpack_public_path__ + "img/Coronavirus-CDC.4a3afe01.png";